import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/icn-check-on.png'
import _imports_1 from '@/assets/images/icn-check-off.png'
import _imports_2 from '@/assets/images/food_noimage.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-689db0c8")

_pushScopeId("data-v-689db0c8")
const _hoisted_1 = { class: "selecting-ingredient-list-item" }
const _hoisted_2 = { class: "selecting-ingredient-list-item-contents" }
const _hoisted_3 = {
  key: 0,
  class: "selecting-ingredient-list-item-contents-check-image",
  src: _imports_0
}
const _hoisted_4 = {
  key: 1,
  class: "selecting-ingredient-list-item-contents-check-image",
  src: _imports_1
}
const _hoisted_5 = {
  key: 1,
  class: "selecting-ingredient-list-item-contents-icon",
  src: _imports_2
}
const _hoisted_6 = { class: "selecting-ingredient-list-item-contents-name-text" }
const _hoisted_7 = /*#__PURE__*/_createVNode("span", { class: "selecting-ingredient-list-item-contents-button-label-text" }, "確認する", -1)
const _hoisted_8 = /*#__PURE__*/_createVNode("div", { class: "selecting-ingredient-list-item-seperator" }, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", {
        class: "selecting-ingredient-list-item-contents-check",
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.selectClick(...args)))
      }, [
        (_ctx.isSelected)
          ? (_openBlock(), _createBlock("img", _hoisted_3))
          : (_openBlock(), _createBlock("img", _hoisted_4))
      ]),
      (_ctx.imageUrl)
        ? (_openBlock(), _createBlock("img", {
            key: 0,
            class: "selecting-ingredient-list-item-contents-icon",
            src: _ctx.imageUrl,
            onError: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onImageError(...args)))
          }, null, 40, ["src"]))
        : (_openBlock(), _createBlock("img", _hoisted_5)),
      _createVNode("div", {
        class: "selecting-ingredient-list-item-contents-name",
        style: { marginRight: _ctx.getMarginRight() }
      }, [
        _createVNode("span", _hoisted_6, _toDisplayString(_ctx.ingredientName), 1)
      ], 4)
    ]),
    (_ctx.isShowButton)
      ? (_openBlock(), _createBlock("div", {
          key: 0,
          class: "selecting-ingredient-list-item-contents-button-label",
          onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.clickButton(...args)))
        }, [
          _hoisted_7
        ]))
      : _createCommentVNode("", true),
    _hoisted_8
  ]))
})